/* Mutates array in place. If item is present in array, it is take out.  If item is not present in array, it is added in */
export default function toggleItemPresenceInArray(arr, item) {
    if (arr.includes(item)) {
        const idx = arr.findIndex(r => r === item);
        arr = arr.splice(idx, 1);
    }
    else {
        arr.push(item);
    }
}
